import React, { useState } from 'react';
import './BlogsPage.css';

const BlogsPage = () => {
  return (
    <div>
      
    </div>
  );
};

export default BlogsPage; 